import {Box} from '@mui/material';

import {NumericInput} from '@/app/shared-components/NumericInput';
import {NumericInputOptionsColorsProps} from '@/app/shared-components/NumericInput/NumericInput';
import {FeeModel, IFee} from '@/dataSource/src/api/payment-link/entities';

import {PaymentLinkFees} from './PaymentLinkFees';

export interface PaymentLinkQRProps {
  feesData?: FeeModel;
  setSelectedFee: React.Dispatch<React.SetStateAction<IFee>>;
  selectedAmount: number;
  setSelectedAmount: React.Dispatch<React.SetStateAction<number>>;
  disableFees?: boolean;
  setIsSelectTabAmount: React.Dispatch<React.SetStateAction<boolean>>;
  optionsColors?: NumericInputOptionsColorsProps;
  maxAmount?: number;
}
export const PaymentLinkQR: React.FC<PaymentLinkQRProps> = ({
  feesData,
  selectedAmount,
  setSelectedAmount,
  disableFees,
  setIsSelectTabAmount,
  optionsColors,
  maxAmount = 200,
}) => {
  return (
    <Box className="payment-link-valid-header-container">
      <Box className="payment-link-valid-header-box">
        <NumericInput
          maxAmount={maxAmount}
          optionsColors={optionsColors}
          options={[20, 50, 75, 100]}
          value={selectedAmount}
          onChange={(value, prefill) => {
            setSelectedAmount(value);
            setIsSelectTabAmount(prefill);
          }}
        />
      </Box>
      {feesData && (
        <PaymentLinkFees
          fees={feesData.fees}
          disable={disableFees}
        />
      )}
    </Box>
  );
};
